import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
  standalone: true,
})
export class ArraySortPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    if (!array) {
      return [];
    }
    return [...array].sort(function (a, b) {
      return (a[field] ?? 0) - (b[field] ?? 0);
    });
  }
}
